import { render, staticRenderFns } from "./WPTextfieldMeasure.vue?vue&type=template&id=585a2055"
import script from "./WPTextfieldMeasure.vue?vue&type=script&lang=ts"
export * from "./WPTextfieldMeasure.vue?vue&type=script&lang=ts"
import style0 from "./WPTextfieldMeasure.vue?vue&type=style&index=0&id=585a2055&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports